import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const GuestListTableTHead = () => (
	<TableHeader className="relative bg-bg-layer-400">
		<TableRow className="hover:bg-transparent">
			<TableHead justifyStyle="center" className="min-w-32  max-w-40 font-semibold">
				オプション名
			</TableHead>

			<TableHead justifyStyle="center" className="min-w-36 max-w-36 font-semibold">
				氏名
			</TableHead>

			<TableHead justifyStyle="center" className="min-w-32 max-w-32 font-semibold">
				電話番号
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				決済方法
			</TableHead>

			<TableHead justifyStyle="center" className="min-w-48 font-semibold">
				メモ
			</TableHead>

			<TableHead />
		</TableRow>
	</TableHeader>
);
